/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

import { DEVICE } from "src/app/globalStyles";

export const LDBlock = styled.div`
  align-items: flex-start;
  border: 1px solid #000;
  color: #000;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  margin-top: 20px;
  padding-bottom: 26px;
  padding-left: 41px;
  padding-right: 41px;
  padding-top: 36px;
  text-decoration: none;
  width: 680px;

  @media (max-width: ${DEVICE.medium}) {
    width: 85%;
  }
  @media (max-width: ${DEVICE.small}) {
    padding-left: 36px;
    padding-right: 36px;
    padding-bottom: 19px;
    padding-top: 33px;
  }
`;

export const LDSectionBlock = styled(LDBlock)`
  align-items: center;
  height: 40px;
  justify-content: center;
  padding-top: 0;
  padding-bottom: 0px;
`;

export const LDLinkBlock = styled(LDBlock)`
  background-color: transparent;
  cursor: pointer;
  :hover {
    background-color: #e1e1e1;
  }
`;

export const LDExternalLinkBlock = styled.a`
  align-items: flex-start;
  border: 1px solid #000;
  color: #000;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  margin-top: 20px;
  padding-bottom: 36px;
  padding-left: 41px;
  padding-right: 41px;
  padding-top: 36px;
  text-decoration: none;
  width: 680px;
  @media (max-width: ${DEVICE.medium}) {
    width: 85%;
  }

  &:hover {
    color: ${({ theme }) => theme.accent};
  }
`;
